const vpaExtranetPrefix = 'VPA_Extranet_'

const LOCAL_STORAGE_KEYS = {
  AFTER_SIGN_IN_URL: `${vpaExtranetPrefix}afterSignInUrl`,
  IS_LOGGING: `${vpaExtranetPrefix}isLogging`,
  FUN_MODE_ENABLED: `${vpaExtranetPrefix}funModeEnabled`,
} as const

type LocalStorageKeys = keyof typeof LOCAL_STORAGE_KEYS
type LocalStorageValues = (typeof LOCAL_STORAGE_KEYS)[LocalStorageKeys]

const SESSION_STORAGE_KEYS = {
  LOCAL_AUTH_LOGIN_TYPE: `${vpaExtranetPrefix}localAuthLoginType`,
} as const

type SessionStorageKeys = keyof typeof SESSION_STORAGE_KEYS
type SessionStorageValues = (typeof SESSION_STORAGE_KEYS)[SessionStorageKeys]

const COOKIE_KEYS = {
  REMEMBER_ME: `${vpaExtranetPrefix}rememberMe`,
  LOGIN_TYPE: `${vpaExtranetPrefix}loginType`,
} as const

type CookieKeys = keyof typeof COOKIE_KEYS
type CookieValues = (typeof COOKIE_KEYS)[CookieKeys]

export type {
  LocalStorageKeys,
  LocalStorageValues,
  SessionStorageKeys,
  SessionStorageValues,
  CookieKeys,
  CookieValues,
}
export { vpaExtranetPrefix, LOCAL_STORAGE_KEYS, SESSION_STORAGE_KEYS, COOKIE_KEYS }
